import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useApiCollection = (endpoint, fallback = []) => {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axios
      .get(`${API}${endpoint}`)
      .then((res) => {
        if (!cancelled) {
          setData(Array.isArray(res.data) ? res.data : fallback);
          setError(null);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          console.error(`Failed to load ${endpoint}`, err);
          setError(err);
          setData(fallback);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint]);

  return { data, loading, error };
};
